/**
 * WP-V2-AV — hook dev: ?avatar=1 / ?anchors=1 uruchamia AvatarDemoScene.
 * Wzorzec jak WP-V2-WC installWorldDev (side-effect + window.__pieskowo).
 */
import type Phaser from 'phaser';
import { AvatarDemoScene } from './AvatarDemoScene.js';

export function isAvatarDevQuery(
  search = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  try {
    const q = new URLSearchParams(search);
    return q.get('avatar') === '1' || q.get('anchors') === '1';
  } catch {
    return false;
  }
}

/**
 * Rejestruje i startuje AvatarDemo (zatrzymuje inne aktywne sceny).
 * @returns true gdy hook zadziałał.
 */
export function installAvatarDevHook(game: Phaser.Game): boolean {
  if (!isAvatarDevQuery()) return false;

  const key = AvatarDemoScene.KEY;
  if (!game.scene.getScene(key)) {
    game.scene.add(key, AvatarDemoScene, false);
  }

  for (const s of game.scene.getScenes(true)) {
    const sk = s.scene.key;
    if (sk !== key) {
      try {
        game.scene.stop(sk);
      } catch {
        /* ignore */
      }
    }
  }

  game.scene.start(key);
  return true;
}

/**
 * Podpina się pod window.__pieskowo gdy ?avatar=1 lub ?anchors=1.
 */
export function autoAttachAvatarDev(timeoutMs = 12_000): void {
  if (typeof window === 'undefined') return;
  if (!isAvatarDevQuery()) return;

  const w = window as unknown as {
    __pieskowo?: Phaser.Game;
    __avatarDevInstalled?: boolean;
  };

  if (w.__avatarDevInstalled) return;

  const started = Date.now();
  const tick = (): void => {
    if (w.__avatarDevInstalled) return;
    const game = w.__pieskowo;
    if (game) {
      window.setTimeout(() => {
        if (w.__avatarDevInstalled) return;
        if (installAvatarDevHook(game)) {
          w.__avatarDevInstalled = true;
        }
      }, 80);
      return;
    }
    if (Date.now() - started < timeoutMs) {
      window.setTimeout(tick, 50);
    }
  };
  tick();
}

autoAttachAvatarDev();
